"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const useControlEvents_1 = __importDefault(require("../../hooks/useControlEvents"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const LoadingPlaceholder_1 = __importDefault(require("../LoadingPlaceholder"));
const Badge_1 = __importDefault(require("./Badge"));
const IconRenderer = ({ control, style, }) => {
    const { Render } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(control);
    (0, useOnLoad_1.default)(control, events);
    const src = (0, react_1.useMemo)(() => {
        if (control.src) {
            return control.src;
        }
        return { name: 'insert_emoticon', family: 'material' };
    }, [control.src]);
    const fontSize = style.fontSize || 10;
    const iconStyle = (0, react_1.useMemo)(() => {
        const computedStyle = {
            paddingBottom: style.paddingBottom,
            paddingLeft: style.paddingLeft,
            paddingRight: style.paddingRight,
            paddingTop: style.paddingTop,
            marginBottom: style.marginBottom,
            marginLeft: style.marginLeft,
            marginRight: style.marginRight,
            marginTop: style.marginTop,
            backgroundColor: style.backgroundColor,
            position: control.hasBadge ? 'relative' : undefined,
        };
        return computedStyle;
    }, [style, control.hasBadge]);
    const badge = (0, react_1.useMemo)(() => control.hasBadge && !!control.badgeText && (react_1.default.createElement(Badge_1.default, { text: control.badgeText, fontSize: fontSize / 3, bgColor: style.badgeColor, textColor: style.badgeTextColor })), [
        control.badgeText,
        control.hasBadge,
        fontSize,
        style.badgeColor,
        style.badgeTextColor,
    ]);
    return (react_1.default.createElement(LoadingPlaceholder_1.default, { control: control, style: style },
        react_1.default.createElement(Render.View, { style: iconStyle },
            react_1.default.createElement(Render.SvgIcon, { name: src.name, family: src.family || 'material', size: fontSize, color: style.color || 'white', onPress: events.onPress }),
            badge)));
};
exports.default = IconRenderer;
